import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e8d07ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filters" }

import { DxToolbarItem } from "devextreme-vue/popup";
import { computed } from "vue";
import ModalBase from "../modals/modal-base.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'grid-filters-base',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The title or heading associated with the component.
   * @type {string}
   * @required
   */
  title: {
    type: String,
    required: true,
  },
  /**
   * The text to display on the Clear button
   * @type {string}
   */
  clearButtonText: {
    type: String,
    default: "Clear",
  },
},
  emits: [
  "update:modelValue",
  "filtersApplied",
  "clearFilters",
],
  setup(__props, { emit }) {

const props = __props;





const showPopup = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

/** Handles the Clear button click event */
const clearFilters = () => {
  emit("clearFilters");
};

const applyFilters = () => {
  showPopup.value = false;
  emit("filtersApplied");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showPopup.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showPopup).value = $event)),
    title: __props.title
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "filters")
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: __props.clearButtonText, onClick: () => clearFilters() }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: 'Apply', onClick: () => applyFilters() }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: 'Close', onClick: () => (showPopup.value = false) }
      }, null, 8, ["options"])
    ]),
    _: 3
  }, 8, ["modelValue", "title"]))
}
}

})